import { Box, Divider, Grid } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import { colors } from 'styles/colors'
import { caseSharedProps } from 'types/types'
import useGlobalStyles from 'styles/globalStyles'
import { memo, useCallback, useMemo, useState } from 'react'
import PositionDialog from 'components/user/PositionDialog/PositionDialog'
import { ProfileProvider } from 'context/ProfileContext'
import { getRegistryCustomFields, listToLabelValueList } from 'common/utils'
import { useRegistryContext } from 'context/RegistryContext'
import { ECustomFieldType } from 'enum/ECustomFieldType'
import CustomField from 'components/inputs/CustomField/CustomField'

interface Props {
  shared: caseSharedProps;
}

function RegistryCustomFields({
  shared,
}: Props) {
  const globalStyles = useGlobalStyles();
  const [open, setOpen] = useState<boolean>(false);
  const { registry } = useRegistryContext();

  const {
    genders,
    userHospitals,
    refetchHospitals,
  } = shared;

  const hospitalsWithAction = useMemo(() => [
    ...(userHospitals || []),
    { value: '__add_hospital__', label: 'Add Institution' },
  ], [userHospitals]);

  const getFieldOptions = (fieldName: string, fieldOptions?: string) => {
    if (fieldOptions) {
      const options = fieldOptions.split(',')
    }
    switch (fieldName) {
      case 'gender':
        return genders;
      case 'institute':
        return hospitalsWithAction;
      default:
        return [];
    }
  }

  const fields = useMemo(() => {
    const basicFields = registry ? getRegistryCustomFields(registry.fields) : [];
    basicFields.forEach(field => {
      if (field.type == ECustomFieldType.DROPDOWN_LIST) {
        if (field.value) {
          field.options = listToLabelValueList(field.value.split(','));
        } else {
          field.options = getFieldOptions(field.name, field.value);
        }
      }
    });
    return basicFields;
  }, [registry]);


  const renderFields = useCallback(() => {

    return (
      <>
        {fields.map(field => {
          return <CustomField key={field.name} field={field} />
        })}
      </>
    )
  }, [fields, genders, hospitalsWithAction]);

  return (
    <ProfileProvider>
      <Box
        className={globalStyles.sectionContainer}
      >
        <Box className={globalStyles.sectionHeader}>
          <CustomText
            text="Custom Fields"
            color={colors.primary}
            fontWeight={600}
          />
        </Box>

        <Divider />

        <Grid container p={3} spacing={1.5}>

          {renderFields()}

        </Grid>

      </Box>


      <PositionDialog
        open={open}
        setOpen={setOpen}
        entity={'position'}
        refetchHospitals={refetchHospitals}
      />
    </ProfileProvider>
  )
}

export default memo(RegistryCustomFields);
